import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Ittaskstable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.ittaskstable_Id,
          sortable: true,
          cell: (row) => <span>{row.ittaskstable_Id}</span>,
        },
        {
          name: "Project Id",
          selector: (row, i) => row.projectid,
          sortable: true,
          cell: (row) => <span>{row.projectid}</span>,
        },
        {
          name: "Project Name",
          selector: (row, i) => row.projectName,
          sortable: true,
          cell: (row) => <span>{row.projectName}</span>,
        },
        {
          name: "Stage Name",
          selector: (row, i) => row.stagename,
          sortable: true,
          cell: (row) => <span>{row.stagename}</span>,
        },
        {
          name: "UserStory ",
          selector: (row, i) => row.userStory,
          sortable: true,
          cell: (row) => <span>{row.userStory}</span>,
        },
        {
          name: "Task Name",
          selector: (row, i) => row.taskName,
          sortable: true,
          cell: (row) => <span>{row.taskName}</span>,
        },
        {
          name: "Task Description",
          selector: (row, i) => row.taskDescription,
          sortable: true,
          cell: (row) => <span>{row.taskDescription}</span>,
        },
        {
          name: "AssignedTo",
          selector: (row, i) => row.assignedTo,
          sortable: true,
          cell: (row) => <span>{row.assignedTo}</span>,
        },
        {
          name: "Estimated Task Time",
          selector: (row, i) => row.estimatedTaskTime,
          sortable: true,
          cell: (row) => <span>{row.estimatedTaskTime}</span>,
        },
        {
          name: "Actual Task Time",
          selector: (row, i) => row.actualTaskTime,
          sortable: true,
          cell: (row) => <span>{row.actualTaskTime}</span>,
        },
        {
          name: "Task Start Time",
          selector: (row, i) => row.taskStartTime,
          sortable: true,
          cell: (row) => <span>{row.taskStartTime}</span>,
        },
        {
          name: "Task End Time",
          selector: (row, i) => row.taskEndTime,
          sortable: true,
          cell: (row) => <span>{row.taskEndTime}</span>,
        },
        {
          name: "Task Review Start Time",
          selector: (row, i) => row.taskReviewStartTime,
          sortable: true,
          cell: (row) => <span>{row.taskReviewStartTime}</span>,
        },
        {
          name: "Task Review End Time",
          selector: (row, i) => row.taskReviewEndTime,
          sortable: true,
          cell: (row) => <span>{row.taskReviewEndTime}</span>,
        },
        {
          name: "Dependency Task ID",
          selector: (row, i) => row.dependencyTaskID,
          sortable: true,
          cell: (row) => <span>{row.dependencyTaskID}</span>,
        },
        {
          name: "Color Code",
          selector: (row, i) => row.colorCode,
          sortable: true,
          cell: (row) => <span>{row.colorCode}</span>,
        },
        {
          name: "Priority",
          selector: (row, i) => row.priority,
          sortable: true,
          cell: (row) => <span>{row.priority}</span>,
        },
        {
          name: "Deployment RequestId",
          selector: (row, i) => row.dummyOne,
          sortable: true,
          cell: (row) => <span>{row.dummyOne}</span>,
        },
        {
          name: "Task Type",
          selector: (row, i) => row.dummyTwo,
          sortable: true,
          cell: (row) => <span>{row.dummyTwo}</span>,
        },
        {
          name: "Task Status",
          selector: (row, i) => row.taskStatus,
          sortable: true,
          cell: (row) => <span>{row.taskStatus}</span>,
        },
        {
          name: "Remarks",
          selector: (row, i) => row.remarks,
          sortable: true,
          cell: (row) => <span>{row.remarks}</span>,
        },
        {
          name: "Completed On",
          selector: (row, i) => row.completedOn,
          sortable: true,
          cell: (row) => <span>{row.completedOn}</span>,
        },
        {
          name: "Requested By",
          selector: (row, i) => row.requestedBy,
          sortable: true,
          cell: (row) => <span>{row.requestedBy}</span>,
        },
        {
          name: "Request Type",
          selector: (row, i) => row.requestType,
          sortable: true,
          cell: (row) => <span>{row.requestType}</span>,
        },
        {
          name: "Client Request Type",
          selector: (row, i) => row.clientRequestType,
          sortable: true,
          cell: (row) => <span>{row.clientRequestType}</span>,
        },
        {
          name: "Request Name",
          selector: (row, i) => row.requestName,
          sortable: true,
          cell: (row) => <span>{row.requestName}</span>,
        },
        {
          name: "Request Date",
          selector: (row, i) => row.requestDate,
          sortable: true,
          cell: (row) => <span>{row.requestDate}</span>,
        },
        {
          name: "Environment Type",
          selector: (row, i) => row.environmentType,
          sortable: true,
          cell: (row) => <span>{row.environmentType}</span>,
        },
        {
          name: "Module Name",
          selector: (row, i) => row.moduleName,
          sortable: true,
          cell: (row) => <span>{row.moduleName}</span>,
        },
        {
          name: "Release Version",
          selector: (row, i) => row.releaseVersion,
          sortable: true,
          cell: (row) => <span>{row.releaseVersion}</span>,
        },
        {
          name: "Deployment Type",
          selector: (row, i) => row.deploymentType,
          sortable: true,
          cell: (row) => <span>{row.deploymentType}</span>,
        },
        {
          name: "Total Count",
          selector: (row, i) => row.totalCount,
          sortable: true,
          cell: (row) => <span>{row.totalCount}</span>,
        },
        {
          name: "Entries Completed",
          selector: (row, i) => row.entriesCompleted,
          sortable: true,
          cell: (row) => <span>{row.entriesCompleted}</span>,
        },
        {
          name: "Pending Count",
          selector: (row, i) => row.pendingCount,
          sortable: true,
          cell: (row) => <span>{row.pendingCount}</span>,
        },
        {
          name: "Dependency Task",
          selector: (row, i) => row.dependencyTaskName,
          sortable: true,
          cell: (row) => <span>{row.dependencyTaskName}</span>,
        },
        {
          name: "Deployment StartTime",
          selector: (row, i) => row.deploymentStartTime,
          sortable: true,
          cell: (row) => <span>{row.deploymentStartTime}</span>,
        },
        {
          name: "Deployment EndTime",
          selector: (row, i) => row.deploymentEndTime,
          sortable: true,
          cell: (row) => <span>{row.deploymentEndTime}</span>,
        },
        {
          name: "Rollback Required",
          selector: (row, i) => row.rollbackRequired,
          sortable: true,
          cell: (row) => <span>{row.rollbackRequired}</span>,
        },
        {
          name: "Rollback Remarks",
          selector: (row, i) => row.rollbackRemarks,
          sortable: true,
          cell: (row) => <span>{row.rollbackRemarks}</span>,
        },
        {
          name: "deploymentRequest Id",
          selector: (row, i) => row.deploymentRequest_Id,
          sortable: true,
          cell: (row) => <span>{row.deploymentRequest_Id}</span>,
        },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.IttaskstableeditHandler(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 100,
      isEditing: false,
      ittaskstable_Id: "",
      itprojectstable: [],
      projectid: "",
      projectName: "",
      userstoriestable: [],
      userStory: "",
      taskName: "",
      taskDescription: "",
      assignedTo: "",
      estimatedTaskTime: "",
      estimatedHours: "",
      estimatedMinutes: "",
      actualTaskTime: "",
      taskStartTime: "",
      taskEndTime: "",
      taskReviewStartTime: "",
      taskReviewEndTime: "",
      dependencyTaskID: "",
      priority: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
      employees: [],
      ittaskstable: [],
      stagename: "",
      leadstages: [],
      colorCode: "",
      selectedProject: [],
      filteredUserStories: [],
      filteredDependencyTasks: [],
      selectedProjectid: [],
      hours: "00",
      minutes: "00",
      deploymentRequestId: "",
      taskType: "",
      taskStatus: "",
      remarks: "",
      completedOn: "",
      requestedBy: "",
      requestType: "",
      clientRequestType: "",
      requestName: "",
      requestDate: "",
      environmentType: "",
      moduleName: "",
      releaseVersion: "",
      deploymentType: "",
      totalCount: "",
      entriesCompleted: "",
      pendingCount: "",
      dependencyTaskName: "",
      deploymentStartTime: "",
      deploymentEndTime: "",
      rollbackRequired: "",
      rollbackRemarks: "",
      deploymentRequest_Id: "",
      //***state
    };
  }
  handleTimeChange = (e) => {
    const { name, value } = e.target;
    const paddedValue = value.padStart(2, "0");

    this.setState(
      {
        [name]: paddedValue,
      },
      () => {
        let { hours, minutes } = this.state;

        // Set default values
        hours = hours ? hours : "00";
        minutes = minutes ? minutes : "00";

        const timeValue = `${hours}:${minutes}`;
        this.setState({ estimatedTaskTime: timeValue });
      },
    );
  };
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      ittaskstable_Id: "",
      projectid: "",
      projectName: "",
      userStory: "",
      taskName: "",
      priority: "",
      stagename: "",
      colorCode: "",
      taskDescription: "",
      assignedTo: "",
      estimatedTaskTime: "",
      actualTaskTime: "",
      taskStartTime: "",
      taskEndTime: "",
      taskReviewStartTime: "",
      taskReviewEndTime: "",
      dependencyTaskID: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
      deploymentRequestId: "",
      taskType: "",
      taskStatus: "",
      remarks: "",
      completedOn: "",
      requestedBy: "",
      requestType: "",
      clientRequestType: "",
      requestName: "",
      requestDate: "",
      environmentType: "",
      moduleName: "",
      releaseVersion: "",
      deploymentType: "",
      totalCount: "",
      entriesCompleted: "",
      pendingCount: "",
      dependencyTaskName: "",
      deploymentStartTime: "",
      deploymentEndTime: "",
      rollbackRequired: "",
      rollbackRemarks: "",
      deploymentRequest_Id: "",
    });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      projectid: "",
      projectName: "",
      stagename: "",
      colorCode: "",
      userStory: "",
      priority: "",
      taskName: "",
      taskDescription: "",
      assignedTo: "",
      estimatedTaskTime: "",
      actualTaskTime: "",
      taskStartTime: "",
      taskEndTime: "",
      taskReviewStartTime: "",
      taskReviewEndTime: "",
      dependencyTaskID: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
      deploymentRequestId: "",
      taskType: "",
      taskStatus: "",
      remarks: "",
      completedOn: "",
      requestedBy: "",
      requestType: "",
      clientRequestType: "",
      requestName: "",
      requestDate: "",
      environmentType: "",
      moduleName: "",
      releaseVersion: "",
      deploymentType: "",
      totalCount: "",
      entriesCompleted: "",
      pendingCount: "",
      dependencyTaskName: "",
      deploymentStartTime: "",
      deploymentEndTime: "",
      rollbackRequired: "",
      rollbackRemarks: "",
      deploymentRequest_Id: "",
    });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  IttaskstableeditHandler = (row) => {
    // e.preventDefault();
    this.setState({
      isEditing: true,
      ittaskstable_Id: row.ittaskstable_Id,
      projectid: row.projectid,
      projectName: row.projectName,
      userStory: row.userStory,
      priority: row.priority,
      stagename: row.stagename,
      colorCode: row.colorCode,
      taskName: row.taskName,
      taskDescription: row.taskDescription,
      assignedTo: row.assignedTo,
      estimatedTaskTime: row.estimatedTaskTime,
      actualTaskTime: row.actualTaskTime,
      taskStartTime: row.taskStartTime,
      taskEndTime: row.taskEndTime,
      taskReviewStartTime: row.taskReviewStartTime,
      taskReviewEndTime: row.taskReviewEndTime,
      dependencyTaskID: row.dependencyTaskID,
      dummyOne: row.dummyOne,
      dummyTwo: row.dummyTwo,
      dummyThree: row.dummyThree,
      dummyFour: row.dummyFour,
      dummyFive: row.dummyFive,
      deploymentRequestId: row.deploymentRequestId,
      taskType: row.taskType,
      taskStatus: row.taskStatus,
      remarks: row.remarks,
      completedOn: row.completedOn,
      requestedBy: row.requestedBy,
      requestType: row.requestType,
      clientRequestType: row.clientRequestType,
      requestName: row.requestName,
      requestDate: row.requestDate,
      environmentType: row.environmentType,
      moduleName: row.moduleName,
      releaseVersion: row.releaseVersion,
      deploymentType: row.deploymentType,
      totalCount: row.totalCount,
      entriesCompleted: row.entriesCompleted,
      pendingCount: row.pendingCount,
      dependencyTaskName: row.dependencyTaskName,
      deploymentStartTime: row.deploymentStartTime,
      deploymentEndTime: row.deploymentEndTime,
      rollbackRequired: row.rollbackRequired,
      rollbackRemarks: row.rollbackRemarks,
      deploymentRequest_Id: row.deploymentRequest_Id,
      //***editstate
    });
  };

  IttaskstablefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Ittaskstable/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ ittaskstable: data.list });
        }
      });
  };
  IttaskstablesubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    const { assignedTo, taskName, ittaskstable } = this.state;
    const isDuplicate = ittaskstable?.some(
      (task) =>
        task.taskName?.trim().toLowerCase() === taskName.trim().toLowerCase() &&
        String(task.assignedTo) === String(assignedTo),
    );

    if (isDuplicate) {
      this.showToast(
        "Duplicate Task: Same task already assigned to this person.",
        "warning",
      );
      return;
    }
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("stagename", this.state.stagename);
    formData.append("assignedTo", this.state.assignedTo);
    formData.append("projectid", this.state.projectid);
    formData.append("projectName", this.state.projectName);
    formData.append("colorCode", this.state.colorCode);
    formData.append("userStory", this.state.userStory);
    formData.append("taskName", this.state.taskName);
    formData.append("taskDescription", this.state.taskDescription);
    formData.append("estimatedTaskTime", this.state.estimatedTaskTime);
    formData.append("actualTaskTime", this.state.actualTaskTime);
    formData.append("taskStartTime", this.state.taskStartTime);
    formData.append("taskEndTime", this.state.taskEndTime);
    formData.append("taskReviewStartTime", this.state.taskReviewStartTime);
    formData.append("taskReviewEndTime", this.state.taskReviewEndTime);
    formData.append("dependencyTaskID", this.state.dependencyTaskID);
    formData.append("priority", this.state.priority);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFour", this.state.dummyFour);
    formData.append("dummyFive", this.state.dummyFive);
    formData.append("deploymentRequestId", this.state.deploymentRequestId);
    formData.append("taskType", this.state.taskType);
    formData.append("taskStatus", this.state.taskStatus);
    formData.append("remarks", this.state.remarks);
    formData.append("completedOn", this.state.completedOn);
    formData.append("requestedBy", this.state.requestedBy);
    formData.append("requestType", this.state.requestType);
    formData.append("clientRequestType", this.state.clientRequestType);
    formData.append("requestName", this.state.requestName);
    formData.append("requestDate", this.state.requestDate);
    formData.append("environmentType", this.state.environmentType);
    formData.append("moduleName", this.state.moduleName);
    formData.append("releaseVersion", this.state.releaseVersion);
    formData.append("deploymentType", this.state.deploymentType);
    formData.append("totalCount", this.state.totalCount);
    formData.append("entriesCompleted", this.state.entriesCompleted);
    formData.append("pendingCount", this.state.pendingCount);
    formData.append("dependencyTaskName", this.state.dependencyTaskName);
    formData.append("deploymentStartTime", this.state.deploymentStartTime);
    formData.append("deploymentEndTime", this.state.deploymentEndTime);
    formData.append("rollbackRequired", this.state.rollbackRequired);
    formData.append("rollbackRemarks", this.state.rollbackRemarks);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    //***tableData*
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Ittaskstable/add", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.IttaskstablefetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            // itprojectstable: [],
            projectid: "",
            projectName: "",
            colorCode: "",
            //userstoriestable: [],
            userStory: "",
            taskName: "",
            taskDescription: "",
            assignedTo: "",
            estimatedTaskTime: "",
            actualTaskTime: "",
            taskStartTime: "",
            taskEndTime: "",
            taskReviewStartTime: "",
            taskReviewEndTime: "",
            dependencyTaskID: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
            dummyFour: "",
            dummyFive: "",
            priority: "",
            deploymentRequestId: "",
            taskType: "",
            taskStatus: "",
            remarks: "",
            completedOn: "",
            requestedBy: "",
            requestType: "",
            clientRequestType: "",
            requestName: "",
            requestDate: "",
            environmentType: "",
            moduleName: "",
            releaseVersion: "",
            deploymentType: "",
            totalCount: "",
            entriesCompleted: "",
            pendingCount: "",
            dependencyTaskName: "",
            deploymentStartTime: "",
            deploymentEndTime: "",
            rollbackRequired: "",
            rollbackRemarks: "",
            deploymentRequest_Id: "",
          });
        }

        this.setState({ loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  IttaskstableupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("stagename", this.state.stagename);
    formData.append("assignedTo", this.state.assignedTo);
    formData.append("projectid", this.state.projectid);
    formData.append("projectName", this.state.projectName);
    formData.append("colorCode", this.state.colorCode);
    formData.append("userStory", this.state.userStory);
    formData.append("taskName", this.state.taskName);
    formData.append("taskDescription", this.state.taskDescription);
    formData.append("estimatedTaskTime", this.state.estimatedTaskTime);
    formData.append("actualTaskTime", this.state.actualTaskTime);
    formData.append("taskStartTime", this.state.taskStartTime);
    formData.append("taskEndTime", this.state.taskEndTime);
    formData.append("taskReviewStartTime", this.state.taskReviewStartTime);
    formData.append("taskReviewEndTime", this.state.taskReviewEndTime);
    formData.append("dependencyTaskID", this.state.dependencyTaskID);
    formData.append("priority", this.state.priority);
    formData.append("ittaskstable_Id", this.state.ittaskstable_Id);
    formData.append("deploymentRequestId", this.state.deploymentRequestId);
    formData.append("taskType", this.state.taskType);
    formData.append("taskStatus", this.state.taskStatus);
    formData.append("remarks", this.state.remarks);
    formData.append("completedOn", this.state.completedOn);
    formData.append("requestedBy", this.state.requestedBy);
    formData.append("requestType", this.state.requestType);
    formData.append("clientRequestType", this.state.clientRequestType);
    formData.append("requestName", this.state.requestName);
    formData.append("requestDate", this.state.requestDate);
    formData.append("environmentType", this.state.environmentType);
    formData.append("moduleName", this.state.moduleName);
    formData.append("releaseVersion", this.state.releaseVersion);
    formData.append("deploymentType", this.state.deploymentType);
    formData.append("totalCount", this.state.totalCount);
    formData.append("entriesCompleted", this.state.entriesCompleted);
    formData.append("pendingCount", this.state.pendingCount);
    formData.append("dependencyTaskName", this.state.dependencyTaskName);
    formData.append("deploymentStartTime", this.state.deploymentStartTime);
    formData.append("deploymentEndTime", this.state.deploymentEndTime);
    formData.append("rollbackRequired", this.state.rollbackRequired);
    formData.append("rollbackRemarks", this.state.rollbackRemarks);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFour", this.state.dummyFour);
    formData.append("dummyFive", this.state.dummyFive);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    //***tableData1
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Ittaskstable/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.IttaskstablefetchHandler();
          this.handleOffcanvasClose();
        }

        this.setState({ loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  componentDidMount() {
    this.IttaskstablefetchHandler();
    this.itprojectstablefetchHandler();
    this.userstoriestablefetchHandler();
    this.employeesfetchHandler();
    this.LeadstagesfetchHandler();

    //***componentDidMount
  }

  LeadstagesfetchHandler = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Leadstages/list", {
      // Enter your IP address here

      method: "POST",

      //headers :{ 'Content-Type' : 'application/json'},

      mode: "cors",

      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ leadstages: data.list });
        }
      });
  };
  employeesfetchHandler = () => {
    fetch(configData.api_url + "C_Employees/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employees: data.list });
        }
      });
  };
  handleprojectidChange = (e) => {
    const selectedProjectId = e.target.value;

    const selectedProject = this.state.itprojectstable.find(
      (project) => project.itprojectstable_Id === selectedProjectId,
    );

    const selectedProjectName = selectedProject?.projectName || "";

    const filteredUserStories = this.state.userstoriestable.filter(
      (story) => story.projectName === selectedProjectName,
    );

    const filteredDependencyTasks = this.state.ittaskstable.filter(
      (task) => task.projectName === selectedProjectName,
    );

    const filteredStages = this.state.leadstages.filter(
      (stage) => stage.projectName === selectedProjectName,
    );

    this.setState({
      projectid: selectedProjectId,
      projectName: selectedProjectName,
      colorCode: selectedProject?.colorCode || "",
      filteredUserStories,
      filteredDependencyTasks,
      filteredStages,
    });
  };
  handleprojectNameChange = (e) => {
    e.preventDefault();
    const selectedProjectName = e.target.value;
    const selectedProject = this.state.itprojectstable.find(
      (project) => project.projectName === selectedProjectName,
    );
    const selectedProjectId = selectedProject?.itprojectstable_Id || "";
    const filteredUserStories = this.state.userstoriestable.filter(
      (story) => story.projectName === selectedProjectName,
    );

    const filteredDependencyTasks = this.state.ittaskstable.filter(
      (task) => task.projectName === selectedProjectName,
    );
    this.setState({
      projectid: selectedProjectId,
      projectName: selectedProjectName,
      colorCode: selectedProject?.colorCode,
      filteredUserStories,
      filteredDependencyTasks,
    });
  };
  itprojectstablefetchHandler = () => {
    fetch(configData.api_url + "C_Itprojectstable/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ itprojectstable: data.list });
        }
      });
  };
  handleuserStoryChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ userStory: fieldValue });
  };
  userstoriestablefetchHandler = () => {
    fetch(configData.api_url + "C_Userstoriestable/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ userstoriestable: data.list });
        }
      });
  };
  handletaskNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskName: fieldValue });
  };
  handletaskDescriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskDescription: fieldValue });
  };
  handleassignedToChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ assignedTo: fieldValue });
  };
  handlestagenameToChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ stagename: fieldValue });
  };
  handleestimatedTaskTimeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ estimatedTaskTime: fieldValue });
  };
  handleactualTaskTimeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ actualTaskTime: fieldValue });
  };
  handletaskStartTimeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ taskStartTime: fieldValue });
  };
  handletaskEndTimeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ taskEndTime: fieldValue });
  };
  handletaskReviewStartTimeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ taskReviewStartTime: fieldValue });
  };
  handletaskReviewEndTimeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ taskReviewEndTime: fieldValue });
  };
  handledependencyTaskIDChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dependencyTaskID: fieldValue });
  };
  handlepriorityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ priority: fieldValue });
  };
  handledummyOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyOne: fieldValue });
  };
  handledummyTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyTwo: fieldValue });
  };
  handledummyThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyThree: fieldValue });
  };
  handledummyFourChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFour: fieldValue });
  };
  handledummyFiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFive: fieldValue });
  };
  handledeploymentRequestIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ deploymentRequestId: fieldValue });
  };
  handletaskTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskType: fieldValue });
  };
  handletaskStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskStatus: fieldValue });
  };
  handleremarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ remarks: fieldValue });
  };
  handlecompletedOnChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ completedOn: fieldValue });
  };
  handlerequestedByChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ requestedBy: fieldValue });
  };
  handlerequestTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ requestType: fieldValue });
  };
  handleclientRequestTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ clientRequestType: fieldValue });
  };
  handlerequestNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ requestName: fieldValue });
  };
  handlerequestDateChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ requestDate: fieldValue });
  };
  handleenvironmentTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ environmentType: fieldValue });
  };
  handlemoduleNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ moduleName: fieldValue });
  };
  handlereleaseVersionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ releaseVersion: fieldValue });
  };
  handledeploymentTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ deploymentType: fieldValue });
  };
  handletotalCountChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ totalCount: fieldValue });
  };
  handleentriesCompletedChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ entriesCompleted: fieldValue });
  };
  handlependingCountChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ pendingCount: fieldValue });
  };
  handledependencyTaskNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dependencyTaskName: fieldValue });
  };
  handledeploymentStartTimeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ deploymentStartTime: fieldValue });
  };
  handledeploymentEndTimeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ deploymentEndTime: fieldValue });
  };
  handlerollbackRequiredChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ rollbackRequired: fieldValue });
  };
  handlerollbackRemarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ rollbackRemarks: fieldValue });
  };
  handledeploymentRequest_IdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ deploymentRequest_Id: fieldValue });
  };
  //***inputFunctions
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("ittaskstable_Id", row.ittaskstable_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Ittaskstable/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.IttaskstablefetchHandler();
        }

        this.setState({ loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.ittaskstable.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };
  handlecolorCodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ colorCode: fieldValue });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        )
      : this.state.ittaskstable.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        );

    return (
      <div className="page-title">
        <LoadingOverlay
          show={this.state.loading}
          message={this.state.loadingMessage}
        />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Tasks
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add IT Tasks</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Project Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select
                                        className="form-select"
                                        name="projectid"
                                        value={this.state.projectid}
                                        onChange={this.handleprojectidChange}
                                      >
                                        <option defaultValue>
                                          Select Project Id
                                        </option>
                                        {this.state.itprojectstable.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.itprojectstable_Id}
                                            >
                                              {api.projectName}
                                            </option>
                                          ),
                                        )}
                                      </select>
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Project Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select
                                        disabled
                                        className="form-select"
                                        name="projectName"
                                        value={this.state.projectName}
                                        onChange={this.handleprojectNameChange}
                                      >
                                        <option defaultValue>
                                          Select Project Name
                                        </option>
                                        {this.state.itprojectstable.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.projectName}
                                            >
                                              {api.projectName}
                                            </option>
                                          ),
                                        )}
                                      </select>
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Color Code
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        disabled
                                        type="color"
                                        onChange={this.handlecolorCodeChange}
                                        className="form-control"
                                        name="colorCode"
                                        value={this.state.colorCode}
                                        required="required"
                                        //  placeholder="Enter Dummy One"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      {/* <Form.Label style={{ paddingTop: "8px" }}>
                                        Color Code Format
                                      </Form.Label> */}
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        disabled
                                        type="text"
                                        onChange={this.handlecolorCodeChange}
                                        className="form-control"
                                        name="colorCode"
                                        value={this.state.colorCode}
                                        required="required"
                                        //  placeholder="Enter Dummy One"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        User Story
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select
                                        className="form-select"
                                        name="userStory"
                                        value={this.state.userStory}
                                        onChange={this.handleuserStoryChange}
                                      >
                                        <option defaultValue>
                                          Select User Story
                                        </option>
                                        {this.state.filteredUserStories.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.userStory}
                                            >
                                              {api.userStory}
                                            </option>
                                          ),
                                        )}
                                      </select>
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Task Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handletaskNameChange}
                                        className="form-control"
                                        name="taskName"
                                        value={this.state.taskName}
                                        required="required"
                                        placeholder="Enter Task Name"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Task Description
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        as="textarea"
                                        rows={4}
                                        onChange={
                                          this.handletaskDescriptionChange
                                        }
                                        className="form-control"
                                        name="taskDescription"
                                        value={this.state.taskDescription}
                                        required="required"
                                        placeholder="Enter Task Description"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Assigned To
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        type="text"
                                        onChange={this.handleassignedToChange}
                                        className="form-select"
                                        name="assignedTo"
                                        value={this.state.assignedTo}
                                        required="required"
                                        placeholder="Enter Assigned To"
                                      >
                                        <option defaultValue>
                                          Select Project Owner
                                        </option>
                                        {this.state.employees.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.employees_Id}
                                            >
                                              {api.fName}&nbsp;{api.lName}
                                            </option>
                                          ),
                                        )}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Stage Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        type="text"
                                        onChange={this.handlestagenameToChange}
                                        className="form-select"
                                        name="stagename"
                                        value={this.state.stagename}
                                        required="required"
                                      >
                                        <option defaultValue>
                                          Select Project Owner
                                        </option>
                                        {this.state.leadstages.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.leadstages_Id}
                                            >
                                              {api.stageName}
                                            </option>
                                          ),
                                        )}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row className="d-flex">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Estimated Task Time
                                      </Form.Label>
                                    </Col>
                                    <Col
                                      lg="8"
                                      md="8"
                                      className="d-flex m-0"
                                      style={{
                                        paddingTop: "8px",
                                        margin: "0px",
                                        padding: "0px",
                                      }}
                                    >
                                      <Form.Group className="d-flex">
                                        <Form.Select
                                          className="form-control"
                                          name="hours"
                                          value={this.state.hours}
                                          onChange={this.handleTimeChange}
                                        >
                                          <option value="">HH</option>
                                          {[...Array(24).keys()].map((hour) => (
                                            <option
                                              key={hour}
                                              value={hour
                                                .toString()
                                                .padStart(2, "0")}
                                            >
                                              {hour.toString().padStart(2, "0")}
                                            </option>
                                          ))}
                                        </Form.Select>

                                        <Form.Select
                                          name="minutes"
                                          value={this.state.minutes}
                                          onChange={this.handleTimeChange}
                                        >
                                          <option value="">MM</option>
                                          {[
                                            1, 2, 3, 4, 5, 10, 15, 20, 25, 30,
                                            45, 50, 55,
                                          ].map((min) => (
                                            <option
                                              key={min}
                                              value={min
                                                .toString()
                                                .padStart(2, "0")}
                                            >
                                              {min.toString().padStart(2, "0")}
                                            </option>
                                          ))}
                                        </Form.Select>
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4"></Col>
                                    <Col lg="8" md="8 ">
                                      <Form.Control
                                        type="text"
                                        value={this.state.estimatedTaskTime}
                                        readOnly
                                        placeholder="HH:MM"
                                      />
                                    </Col>
                                  </Row>
                                  {/* <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Actual Task Time
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="time"
                                        onChange={
                                          this.handleactualTaskTimeChange
                                        }
                                        className="form-control"
                                        name="actualTaskTime"
                                        value={this.state.actualTaskTime}
                                        required="required"
                                        placeholder="Enter Actual Task Time"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Task Start Time
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="time"
                                        onChange={
                                          this.handletaskStartTimeChange
                                        }
                                        className="form-control"
                                        name="taskStartTime"
                                        value={this.state.taskStartTime}
                                        required="required"
                                        placeholder="Enter Task Start Time"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Task End Time
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="time"
                                        onChange={this.handletaskEndTimeChange}
                                        className="form-control"
                                        name="taskEndTime"
                                        value={this.state.taskEndTime}
                                        required="required"
                                        placeholder="Enter Task End Time"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Task Review Start Time
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="time"
                                        onChange={
                                          this.handletaskReviewStartTimeChange
                                        }
                                        className="form-control"
                                        name="taskReviewStartTime"
                                        value={this.state.taskReviewStartTime}
                                        required="required"
                                        placeholder="Enter Task Review Start Time"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Task Review End Time
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="time"
                                        onChange={
                                          this.handletaskReviewEndTimeChange
                                        }
                                        className="form-control"
                                        name="taskReviewEndTime"
                                        value={this.state.taskReviewEndTime}
                                        required="required"
                                        placeholder="Enter Task Review End Time"
                                      />
                                    </Col>
                                  </Row> */}
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Priority
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlepriorityChange}
                                        className="form-control"
                                        name="priority"
                                        value={this.state.priority}
                                        required="required"
                                        placeholder="Enter Priority"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dependency Task ID
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        type="text"
                                        onChange={
                                          this.handledependencyTaskIDChange
                                        }
                                        className="form-control"
                                        name="dependencyTaskID"
                                        value={this.state.dependencyTaskID}
                                        required="required"
                                        placeholder="Enter Dependency Task ID"
                                      >
                                        <option defaultValue>
                                          Select Task
                                        </option>
                                        {this.state.filteredDependencyTasks.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.taskName}
                                            >
                                              {api.taskName}
                                              {/* {api.fName}&nbsp;{api.lName} */}
                                            </option>
                                          ),
                                        )}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        deployment RequestId
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handledeploymentRequestIdChange
                                        }
                                        className="form-control"
                                        name="deploymentRequestId"
                                        value={this.state.deploymentRequestId}
                                        required="required"
                                        placeholder="Enter Deployment Request ID"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Task Type
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handletaskTypeChange}
                                        className="form-control"
                                        name="taskType"
                                        value={this.state.taskType}
                                        required="required"
                                        placeholder="Enter Task Type"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Task Status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handletaskStatusChange}
                                        className="form-control"
                                        name="taskStatus"
                                        value={this.state.taskStatus}
                                        required="required"
                                        placeholder="Enter Task Status"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Remarks
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleremarksChange}
                                        className="form-control"
                                        name="remarks"
                                        value={this.state.remarks}
                                        required="required"
                                        placeholder="Enter Remarks"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Completed On
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlecompletedOnChange}
                                        className="form-control"
                                        name="completedOn"
                                        value={this.state.completedOn}
                                        required="required"
                                        placeholder="Enter Completed On"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Requested By
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlerequestedByChange}
                                        className="form-control"
                                        name="requestedBy"
                                        value={this.state.requestedBy}
                                        required="required"
                                        placeholder="Enter Requested By"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Request Type
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlerequestTypeChange}
                                        className="form-control"
                                        name="requestType"
                                        value={this.state.requestType}
                                        required="required"
                                        placeholder="Enter Request Type"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Client Request Type
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleclientRequestTypeChange
                                        }
                                        className="form-control"
                                        name="clientRequestType"
                                        value={this.state.clientRequestType}
                                        required="required"
                                        placeholder="Enter Client Request Type"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Request Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlerequestNameChange}
                                        className="form-control"
                                        name="requestName"
                                        value={this.state.requestName}
                                        required="required"
                                        placeholder="Enter Request Name"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Request Date
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={this.handlerequestDateChange}
                                        className="form-control"
                                        name="requestDate"
                                        value={this.state.requestDate}
                                        required="required"
                                        placeholder="Enter Request Date"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Environment Type
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleenvironmentTypeChange
                                        }
                                        className="form-control"
                                        name="environmentType"
                                        value={this.state.environmentType}
                                        required="required"
                                        placeholder="Enter Environment Type"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Module Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlemoduleNameChange}
                                        className="form-control"
                                        name="moduleName"
                                        value={this.state.moduleName}
                                        required="required"
                                        placeholder="Enter Module Name"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Release Version
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlereleaseVersionChange
                                        }
                                        className="form-control"
                                        name="releaseVersion"
                                        value={this.state.releaseVersion}
                                        required="required"
                                        placeholder="Enter Release Version"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        deployment Type
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handledeploymentTypeChange
                                        }
                                        className="form-control"
                                        name="deploymentType"
                                        value={this.state.deploymentType}
                                        required="required"
                                        placeholder="Enter Deployment Type"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Total Count
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handletotalCountChange}
                                        className="form-control"
                                        name="totalCount"
                                        value={this.state.totalCount}
                                        required="required"
                                        placeholder="Enter Total Count"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Entries Completed
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleentriesCompletedChange
                                        }
                                        className="form-control"
                                        name="entriesCompleted"
                                        value={this.state.entriesCompleted}
                                        required="required"
                                        placeholder="Enter Entries Completed"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Pending Count
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlependingCountChange}
                                        className="form-control"
                                        name="pendingCount"
                                        value={this.state.pendingCount}
                                        required="required"
                                        placeholder="Enter Pending Count"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dependency Task Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handledependencyTaskNameChange
                                        }
                                        className="form-control"
                                        name="dependencyTaskName"
                                        value={this.state.dependencyTaskName}
                                        required="required"
                                        placeholder="Enter Dependency Task Name"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Deployment Start Time
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="time"
                                        onChange={
                                          this.handledeploymentStartTimeChange
                                        }
                                        className="form-control"
                                        name="deploymentStartTime"
                                        value={this.state.deploymentStartTime}
                                        required="required"
                                        placeholder="Enter Deployment Start Time"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Deployment End Time
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="time"
                                        onChange={
                                          this.handledeploymentEndTimeChange
                                        }
                                        className="form-control"
                                        name="deploymentEndTime"
                                        value={this.state.deploymentEndTime}
                                        required="required"
                                        placeholder="Enter Deployment End Time"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Rollback Required
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlerollbackRequiredChange
                                        }
                                        className="form-control"
                                        name="rollbackRequired"
                                        value={this.state.rollbackRequired}
                                        required="required"
                                        placeholder="Enter Rollback Required"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Rollback Remarks
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlerollbackRemarksChange
                                        }
                                        className="form-control"
                                        name="rollbackRemarks"
                                        value={this.state.rollbackRemarks}
                                        required="required"
                                        placeholder="Enter Rollback Remarks"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Deployment Request Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handledeploymentRequest_IdChange
                                        }
                                        className="form-control"
                                        name="deploymentRequest_Id"
                                        value={this.state.deploymentRequest_Id}
                                        required="required"
                                        placeholder="Enter Deployment Request Id"
                                      />
                                    </Col>
                                  </Row>
                                  {/* tableContent */}
                                </Form>
                              </Row>
                              <Row>
                                <Col className="d-flex justify-content-end">
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.IttaskstablesubmitHandler}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Save
                                  </Button>
                                </Col>
                              </Row>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {this.state.isEditing && (
                        // Edit Offcanvas
                        <Offcanvas
                          show={this.state.isEditing}
                          // onHide={() => this.setState({ isEditing: false })}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit IT Tasks</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Project Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select
                                          className="form-select"
                                          name="projectid"
                                          value={this.state.projectid}
                                          onChange={this.handleprojectidChange}
                                        >
                                          <option defaultValue>
                                            Select Project Id
                                          </option>
                                          {this.state.itprojectstable.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.itprojectstable_Id}
                                              >
                                                {api.projectName}
                                              </option>
                                            ),
                                          )}
                                        </select>
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Project Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select
                                          disabled
                                          className="form-select"
                                          name="projectName"
                                          value={this.state.projectName}
                                          onChange={
                                            this.handleprojectNameChange
                                          }
                                        >
                                          <option defaultValue>
                                            Select Project Name
                                          </option>
                                          {this.state.itprojectstable.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.projectName}
                                              >
                                                {api.projectName}
                                              </option>
                                            ),
                                          )}
                                        </select>
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Color Code
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          disabled
                                          type="color"
                                          onChange={this.handlecolorCodeChange}
                                          className="form-control"
                                          name="colorCode"
                                          value={this.state.colorCode}
                                          required="required"
                                          //  placeholder="Enter Dummy One"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        {/* <Form.Label style={{ paddingTop: "8px" }}>
                                        Color Code Format
                                      </Form.Label> */}
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          disabled
                                          type="text"
                                          onChange={this.handlecolorCodeChange}
                                          className="form-control"
                                          name="colorCode"
                                          value={this.state.colorCode}
                                          required="required"
                                          //  placeholder="Enter Dummy One"
                                        />
                                      </Col>
                                    </Row>
                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          User Story
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select
                                          className="form-select"
                                          name="userStory"
                                          value={this.state.userStory}
                                          onChange={this.handleuserStoryChange}
                                        >
                                          <option defaultValue>
                                            Select User Story
                                          </option>
                                          {this.state.userstoriestable.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.userStory}
                                              >
                                                {api.userStory}
                                              </option>
                                            ),
                                          )}
                                        </select>
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Task Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handletaskNameChange}
                                          className="form-control"
                                          name="taskName"
                                          value={this.state.taskName}
                                          required="required"
                                          placeholder="Enter Task Name"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Task Description
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          as="textarea"
                                          rows={4}
                                          onChange={
                                            this.handletaskDescriptionChange
                                          }
                                          className="form-control"
                                          name="taskDescription"
                                          value={this.state.taskDescription}
                                          required="required"
                                          placeholder="Enter Task Description"
                                        />
                                      </Col>
                                    </Row>
                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Assigned To
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Select
                                          type="text"
                                          onChange={this.handleassignedToChange}
                                          className="form-select"
                                          name="assignedTo"
                                          value={this.state.assignedTo}
                                          required="required"
                                          placeholder="Enter AssignedTo"
                                        >
                                          <option defaultValue>
                                            Select Project Owner
                                          </option>
                                          {this.state.employees.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.employees_Id}
                                              >
                                                {api.fName}&nbsp;{api.lName}
                                              </option>
                                            ),
                                          )}
                                        </Form.Select>
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Stage Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Select
                                          type="text"
                                          onChange={
                                            this.handlestagenameToChange
                                          }
                                          className="form-select"
                                          name="stagename"
                                          value={this.state.stagename}
                                          required="required"
                                        >
                                          <option defaultValue>
                                            Select Stage
                                          </option>
                                          {this.state.leadstages.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.leadstages_Id}
                                              >
                                                {api.stageName}
                                              </option>
                                            ),
                                          )}
                                        </Form.Select>
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row className="d-flex">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Estimated Task Time
                                        </Form.Label>
                                      </Col>
                                      <Col
                                        lg="8"
                                        md="8"
                                        className="d-flex m-0"
                                        style={{
                                          paddingTop: "8px",
                                          margin: "0px",
                                          padding: "0px",
                                        }}
                                      >
                                        <Form.Group className="d-flex">
                                          <Form.Select
                                            className="form-control"
                                            name="hours"
                                            value={this.state.hours}
                                            onChange={this.handleTimeChange}
                                          >
                                            <option value="">HH</option>
                                            {[...Array(24).keys()].map(
                                              (hour) => (
                                                <option
                                                  key={hour}
                                                  value={hour
                                                    .toString()
                                                    .padStart(2, "0")}
                                                >
                                                  {hour
                                                    .toString()
                                                    .padStart(2, "0")}
                                                </option>
                                              ),
                                            )}
                                          </Form.Select>

                                          <Form.Select
                                            name="minutes"
                                            value={this.state.minutes}
                                            onChange={this.handleTimeChange}
                                          >
                                            <option value="">MM</option>
                                            {[
                                              1, 2, 3, 4, 5, 10, 15, 20, 25, 30,
                                              45, 50, 55,
                                            ].map((min) => (
                                              <option
                                                key={min}
                                                value={min
                                                  .toString()
                                                  .padStart(2, "0")}
                                              >
                                                {min
                                                  .toString()
                                                  .padStart(2, "0")}
                                              </option>
                                            ))}
                                          </Form.Select>
                                        </Form.Group>
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4"></Col>
                                      <Col lg="8" md="8 ">
                                        <Form.Control
                                          type="text"
                                          value={this.state.estimatedTaskTime}
                                          readOnly
                                          placeholder="HH:MM"
                                        />
                                      </Col>
                                    </Row>
                                    {/* <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Actual Task Time
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="time"
                                        onChange={
                                          this.handleactualTaskTimeChange
                                        }
                                        className="form-control"
                                        name="actualTaskTime"
                                        value={this.state.actualTaskTime}
                                        required="required"
                                        placeholder="Enter Actual Task Time"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Task Start Time
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="time"
                                        onChange={
                                          this.handletaskStartTimeChange
                                        }
                                        className="form-control"
                                        name="taskStartTime"
                                        value={this.state.taskStartTime}
                                        required="required"
                                        placeholder="Enter Task Start Time"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Task End Time
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="time"
                                        onChange={this.handletaskEndTimeChange}
                                        className="form-control"
                                        name="taskEndTime"
                                        value={this.state.taskEndTime}
                                        required="required"
                                        placeholder="Enter Task End Time"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Task Review Start Time
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="time"
                                        onChange={
                                          this.handletaskReviewStartTimeChange
                                        }
                                        className="form-control"
                                        name="taskReviewStartTime"
                                        value={this.state.taskReviewStartTime}
                                        required="required"
                                        placeholder="Enter Task Review Start Time"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Task Review End Time
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="time"
                                        onChange={
                                          this.handletaskReviewEndTimeChange
                                        }
                                        className="form-control"
                                        name="taskReviewEndTime"
                                        value={this.state.taskReviewEndTime}
                                        required="required"
                                        placeholder="Enter Task Review End Time"
                                      />
                                    </Col>
                                  </Row> */}
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Priority
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlepriorityChange}
                                          className="form-control"
                                          name="priority"
                                          value={this.state.priority}
                                          required="required"
                                          placeholder="Enter Priority"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Dependency Task ID
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Select
                                          type="text"
                                          onChange={
                                            this.handledependencyTaskIDChange
                                          }
                                          className="form-control"
                                          name="dependencyTaskID"
                                          value={this.state.dependencyTaskID}
                                          required="required"
                                          placeholder="Enter Dependency Task ID"
                                        >
                                          <option defaultValue>
                                            Select Task
                                          </option>
                                          {this.state.ittaskstable.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.taskName}
                                              >
                                                {api.taskName}
                                                {/* {api.fName}&nbsp;{api.lName} */}
                                              </option>
                                            ),
                                          )}
                                        </Form.Select>
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          deployment RequestId
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handledeploymentRequestIdChange
                                          }
                                          className="form-control"
                                          name="deploymentRequestId"
                                          value={this.state.deploymentRequestId}
                                          required="required"
                                          placeholder="Enter Deployment Request ID"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Task Type
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handletaskTypeChange}
                                          className="form-control"
                                          name="taskType"
                                          value={this.state.taskType}
                                          required="required"
                                          placeholder="Enter Task Type"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Task Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handletaskStatusChange}
                                          className="form-control"
                                          name="taskStatus"
                                          value={this.state.taskStatus}
                                          required="required"
                                          placeholder="Enter Task Status"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Remarks
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleremarksChange}
                                          className="form-control"
                                          name="remarks"
                                          value={this.state.remarks}
                                          required="required"
                                          placeholder="Enter Remarks"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Completed On
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlecompletedOnChange
                                          }
                                          className="form-control"
                                          name="completedOn"
                                          value={this.state.completedOn}
                                          required="required"
                                          placeholder="Enter Completed On"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Requested By
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlerequestedByChange
                                          }
                                          className="form-control"
                                          name="requestedBy"
                                          value={this.state.requestedBy}
                                          required="required"
                                          placeholder="Enter Requested By"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Request Type
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlerequestTypeChange
                                          }
                                          className="form-control"
                                          name="requestType"
                                          value={this.state.requestType}
                                          required="required"
                                          placeholder="Enter Request Type"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Client Request Type
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleclientRequestTypeChange
                                          }
                                          className="form-control"
                                          name="clientRequestType"
                                          value={this.state.clientRequestType}
                                          required="required"
                                          placeholder="Enter Client Request Type"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Request Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlerequestNameChange
                                          }
                                          className="form-control"
                                          name="requestName"
                                          value={this.state.requestName}
                                          required="required"
                                          placeholder="Enter Request Name"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Request Date
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={
                                            this.handlerequestDateChange
                                          }
                                          className="form-control"
                                          name="requestDate"
                                          value={this.state.requestDate}
                                          required="required"
                                          placeholder="Enter Request Date"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Environment Type
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleenvironmentTypeChange
                                          }
                                          className="form-control"
                                          name="environmentType"
                                          value={this.state.environmentType}
                                          required="required"
                                          placeholder="Enter Environment Type"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Module Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlemoduleNameChange}
                                          className="form-control"
                                          name="moduleName"
                                          value={this.state.moduleName}
                                          required="required"
                                          placeholder="Enter Module Name"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Release Version
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlereleaseVersionChange
                                          }
                                          className="form-control"
                                          name="releaseVersion"
                                          value={this.state.releaseVersion}
                                          required="required"
                                          placeholder="Enter Release Version"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          deployment Type
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handledeploymentTypeChange
                                          }
                                          className="form-control"
                                          name="deploymentType"
                                          value={this.state.deploymentType}
                                          required="required"
                                          placeholder="Enter Deployment Type"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Total Count
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handletotalCountChange}
                                          className="form-control"
                                          name="totalCount"
                                          value={this.state.totalCount}
                                          required="required"
                                          placeholder="Enter Total Count"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Entries Completed
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleentriesCompletedChange
                                          }
                                          className="form-control"
                                          name="entriesCompleted"
                                          value={this.state.entriesCompleted}
                                          required="required"
                                          placeholder="Enter Entries Completed"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Pending Count
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlependingCountChange
                                          }
                                          className="form-control"
                                          name="pendingCount"
                                          value={this.state.pendingCount}
                                          required="required"
                                          placeholder="Enter Pending Count"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Dependency Task Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handledependencyTaskNameChange
                                          }
                                          className="form-control"
                                          name="dependencyTaskName"
                                          value={this.state.dependencyTaskName}
                                          required="required"
                                          placeholder="Enter Dependency Task Name"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Deployment Start Time
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="time"
                                          onChange={
                                            this.handledeploymentStartTimeChange
                                          }
                                          className="form-control"
                                          name="deploymentStartTime"
                                          value={this.state.deploymentStartTime}
                                          required="required"
                                          placeholder="Enter Deployment Start Time"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Deployment End Time
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="time"
                                          onChange={
                                            this.handledeploymentEndTimeChange
                                          }
                                          className="form-control"
                                          name="deploymentEndTime"
                                          value={this.state.deploymentEndTime}
                                          required="required"
                                          placeholder="Enter Deployment End Time"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Rollback Required
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlerollbackRequiredChange
                                          }
                                          className="form-control"
                                          name="rollbackRequired"
                                          value={this.state.rollbackRequired}
                                          required="required"
                                          placeholder="Enter Rollback Required"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Rollback Remarks
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlerollbackRemarksChange
                                          }
                                          className="form-control"
                                          name="rollbackRemarks"
                                          value={this.state.rollbackRemarks}
                                          required="required"
                                          placeholder="Enter Rollback Remarks"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Deployment Request Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this
                                              .handledeploymentRequest_IdChange
                                          }
                                          className="form-control"
                                          name="deploymentRequest_Id"
                                          value={
                                            this.state.deploymentRequest_Id
                                          }
                                          required="required"
                                          placeholder="Enter Deployment Request Id"
                                        />
                                      </Col>
                                    </Row>
                                    {/* tableContent */}
                                  </Form>
                                </Row>
                                <Row>
                                  <Col className="d-flex justify-content-end">
                                    <Button
                                      className="button"
                                      variant="success"
                                      onClick={this.IttaskstableupdateHandler}
                                      style={{
                                        marginTop: "20px",
                                      }}
                                    >
                                      Update
                                    </Button>
                                  </Col>
                                </Row>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.ittaskstable.length
                        }
                        paginationRowsPerPageOptions={[
                          100, 200, 300, 500, 600, 700, 800, 900, 1000,
                        ]}
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
